import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Input, Form, Button } from "antd";
import { toastSuccess } from "../Helpers/Toasters";
import { useState } from "react";

const ContactUs = () => {
  const { language } = useSelector((state) => state.lang);
  const [messageDir, setMessageDir] = useState("");
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const initialValues = {
    email: "",
    mobile: "",
    message: "",
  };

  const handleTeaxAreaChange = (e) => {
    if (e.target.value && /^[\u0600-\u06FF]$/.test(e.target.value[0])) {
      setMessageDir("rtl");
    } else {
      setMessageDir("ltr");
    }
  };

  const handlePreventLetters = (e, allowFloat = true) => {
    if (
      e.key === "Backspace" ||
      (e.key === "." && allowFloat) ||
      (e.key.startsWith("Arrow") &&
        (e.key.startsWith("ArrowLeft") || e.key.startsWith("ArrowRight")))
    )
      return;
    if (/\D+/gi.test(e.key)) {
      e.preventDefault();
    }
  };

  const validatePhoneNumber = (phone) => {
    let phoneLen = 11;
    let charLen = 2; // will validate that user enters 0 and first two numbers inputed are 01
    if (phone.startsWith("2")) {
      phoneLen = 12;
      charLen = 3; // will validate that user entered 2 and first two number inputed are 0 and 1
    }
    if (
      phone.length > phoneLen ||
      (phone.length >= charLen &&
        !phone.startsWith(`${charLen === 2 ? "0" : "20"}1`)) ||
      (phone.length >= charLen + 1 &&
        !phone.startsWith(`${charLen === 2 ? "0" : "20"}10`) &&
        !phone.startsWith(`${charLen === 2 ? "0" : "20"}11`) &&
        !phone.startsWith(`${charLen === 2 ? "0" : "20"}12`) &&
        !phone.startsWith(`${charLen === 2 ? "0" : "20"}15`)) ||
      phone.length < phoneLen
    ) {
      return false;
    } else {
      return true;
    }
  };

  const validateMobileNumber = (_, value) => {
    if (!value) {
      return Promise.reject(new Error(t("contactUs.requiredMobile")));
    } else if (!validatePhoneNumber(value)) {
      return Promise.reject(new Error(t("contactUs.invalidMobile")));
    } else {
      return Promise.resolve();
    }
  };

  const handleSubmit = (values) => {
    toastSuccess(t("contactUs.sentSuccessfully"));
    form.resetFields();
  };

  return (
    <section
      dir={language === "en" ? "ltr" : "rtl"}
      className="contact bg--main-stars flex-fill"
    >
      <h1 className="text-capitalize text-center text--green fw-bold fsize--3 mb-5">
        {t("navbar.contactUs")}
      </h1>
      <Form form={form} initialValues={initialValues} onFinish={handleSubmit}>
        <div className="mb-4">
          <h2 className="fw-bold fsize--5 text--green mb-3">
            {t("contactUs.mobile")}
          </h2>
          <Form.Item
            className="input-holder"
            name="mobile"
            rules={[{ validator: validateMobileNumber }]}
          >
            <Input
              dir="ltr"
              type="text"
              placeholder={t("contactUs.enterMobile")}
              onKeyDown={(e) => handlePreventLetters(e, false)}
              className="contact__mobile-input fsize--6 py-1"
            />
          </Form.Item>
        </div>
        <div className="mb-4">
          <h2 className="fw-bold fsize--5 text--green mb-3">
            {t("contactUs.email")}
          </h2>
          <Form.Item
            className="input-holder"
            name="email"
            rules={[
              {
                required: true,
                message: t("contactUs.requiredEmail"),
              },
              { type: "email", message: t("contactUs.invalidEmail") },
            ]}
          >
            <Input
              dir="ltr"
              type="text"
              placeholder={t("contactUs.enterEmail")}
              className="contact__email-input fsize--6 py-1"
            />
          </Form.Item>
        </div>
        <div className="mb-5">
          <h2 className="fw-bold fsize--5 text--green mb-3">
            {t("contactUs.message")}
          </h2>
          <Form.Item
            className="input-holder"
            name="message"
            rules={[
              {
                required: true,
                message: t("contactUs.requiredMessage"),
              },
            ]}
          >
            <Input.TextArea
              placeholder={t("contactUs.enterMessage")}
              className="contact__text-area fsize--6"
              rows={3}
              dir={messageDir}
              onChange={handleTeaxAreaChange}
              autoSize={false}
            />
          </Form.Item>
        </div>
        <Button
          htmlType="submit"
          className="contact__submit-btn border-0 outline-none shadow-none fsize--5 text--green h-auto"
        >
          {t("contactUs.send")}
        </Button>
      </Form>
    </section>
  );
};

export default ContactUs;
